export default __webpack_public_path__ + "static/media/svg-3.49a7e002.svg";